<template>
  <div class="product">
    <div class="product-list">
      <div class="title">
        末世部落
      </div>
      <div class="product-main">
        <div class="product-text">
          <p>
              《末世部落》英雄介绍——朱骨力
          </p>
          <p>
              织网缠绕阻移动，缚体虫茧作用多。
          </p>
          <p>
              猎食飞扑可瞬移，爆虫大军快远离。
          </p>
          <p>
              技能介绍：
          </p>
          <p>
              织网弹：朱骨力发射织网弹造成敌方单位魔法伤害，并对敌方单位附加4回合的缠绕效果。缠绕状态下移动速度减半。2层缠绕时会被束缚导致无法移动，持续4回合；
          </p>
          <p>
              缚体虫茧：朱骨力发射高级织网弹对敌方单位造成魔法伤害，对敌方单位附加4回合的缠绕效果。精准命中还会将敌方单位变为可释放技能但无法移动的茧，任何攻击都会解除茧化状态，持续2回合；
          </p>
          <p>
              猎食飞扑：朱骨力发射定位弹对敌方单位造成魔法伤害，随后高高的跃起扑向定位点，对敌方单位造成伤害。如击中变成茧的敌方单位时朱骨力恢复伤害量50%的生命值，且不会打破茧化状态；
          </p>
          <p>
              爆虫大军：朱骨力释放放出9只爆虫，爆虫在着陆后会沿地面行进，遭遇任意敌方单位或无法逾越的阻挡时造成魔法伤害；
          </p>
          <p>
              被动技能：
          </p>
          <p>
              隐蔽猎手：朱骨力是善于隐蔽的猎手，处于受到缠绕或束缚效果的敌方单位附近时获得隐身效果&nbsp;&nbsp;
          </p>
          <p>
              <img src="~@/assets/images/msbl/1.jpg" alt="">
          </p>
          <p>
              《末世部落》英雄介绍——灾变
          </p>
          <p>
              巨石投掷高伤害，火石攻击持续烧。
          </p>
          <p>
              精准命中可眩晕，巨石碎裂满地伤。
          </p>
          <p>
              技能介绍：
          </p>
          <p>
              巨石：投石车投掷巨石，对敌方单位造成伤害；
          </p>
          <p>
              火石：投石车投掷火石，对敌方单位造成火属性伤害，并点燃命中区域附近，火焰每2秒对点燃的敌方单位造成火属性伤害，火焰持续存在90秒；
          </p>
          <p>
              花岗岩：投石车投掷花岗巨岩，对敌方单位造成伤害，并对精准命中的敌方单位附加击晕效果，使其无法进行任何行动，持续2回合
          </p>
          <p>
              巨石碎裂：投石车发射超级巨石造成伤害，并对精准命中的敌方单位附加击晕效果，使其无法进行任何行动，持续2回合，巨石会碎裂成4块碎石，每块碎石可对命中的敌方单位造成伤害；
          </p>
          <p>
              被动技能：
          </p>
          <p>
              异常抵抗：投石车有很强的精神力量，受到的负面状态时有35%概率抵抗。&nbsp;
          </p>
          <p>
              <img src="~@/assets/images/msbl/2.jpg" alt="">
          </p>
          <p>
              《末世部落》英雄介绍——虚空
          </p>
          <p>
              虚空碎块沿地滚，异动漩涡带闪电，
          </p>
          <p>
              时光回溯可治愈，深渊黑洞最致命！
          </p>
          <p>
              技能介绍：
          </p>
          <p>
              虚空碎块：虚空抛出虚空碎块，虚空碎块着陆后会沿地面滚动行进，遭遇敌方单位或阻挡时造成魔法伤害；
          </p>
          <p>
              异动漩涡：虚空发射一枚定位弹，治疗我方单位生命，对方单位造成魔法伤害，并在命中位置上空制造出持续2回合的异动漩涡，漩涡吞噬大部分敌方炮弹，再转化为闪电随机发射，造成雷属性伤害；
          </p>
          <p>
              时光回溯：虚空为目标注入时空能量，治疗我方单位生命，对敌方单位造成魔法伤害，并附加回溯效果，记录目标当前状态，2回合后目标回溯恢复至之前记录的状态；
          </p>
          <p>
              深渊黑洞：虚空发射一股黑暗能量，造成敌方单位魔法伤害，并引发空间瓦解，将范围内的目标拉扯至命中点造成魔法伤害
          </p>
          <p>
              被动技能：
          </p>
          <p>
              维度行走：虚空移动过程中不会下落，保持水平前进，可以越过凹陷地形。
          </p>
          <p>
              <img src="~@/assets/images/msbl/3.jpg" alt="">
          </p>
          <p>
              《末世部落》英雄介绍——沃特
          </p>
          <p>
              水火不惧看沃特，水弹攻击是威慑，
          </p>
          <p>
              胶水攻击可定身，冰冻冰爆动不得。
          </p>
          <p>
              技能介绍：
          </p>
          <p>
              水弹：沃特发射一枚巨大的水弹，对敌方单位造成水属性伤害；
          </p>
          <p>
              胶水弹：沃特发射胶水弹，对敌方单位造成水属性伤害，并对精确命中的敌方单位附加定身效果，使目标无法移动，持续2回合；
          </p>
          <p>
              冰冻弹：沃特发射冰冻弹，对敌方单位造成水属性伤害，并对精准命中的敌方单位附加冰冻效果，使目标无法进行任何操作，持续2回合，冰冻状态下受到伤害减伤50%，只能由受困方的队友通过攻击或治疗解冻；
          </p>
          <p>
              冰爆弹：沃特发射冰爆弹，对命中点附近范围内的敌方单位造成无衰减的水属性伤害，并附加冰冻效果，使目标无法进行任何操作，持续2回合，冰冻状态下受到伤害减伤50%，只能由受困方的队友通过攻击或治疗解冻；
          </p>
          <p>
              被动技能：
          </p>
          <p>
              水火屏障：沃特水火不惧，水属性抗性增加100，火属性抗性增加100。
          </p>
          <p>
              <img src="~@/assets/images/msbl/4.jpg" alt="">
          </p>
          <p>
              《末世部落》英雄介绍——天火
          </p>
          <p>
              反隐侦测无所遁，传送命中能瞬移。
          </p>
          <p>
              定位打击附穿透，6颗航弹人踪灭。
          </p>
          <p>
              技能介绍：
          </p>
          <p>
              火箭弹：天火发射火箭弹，对敌方单位造成伤害；
          </p>
          <p>
              传送弹：天火发射传送弹，然后瞬移到命中点。若传送弹命中英雄，造成伤害并与命中的英雄互换位置并隐身2回合。使用该技能不会导致行动结束；
          </p>
          <p>
              定位打击：天火发射一枚引导弹，对敌方单位造成伤害，在命中的位置垂直落下1颗有穿透效果的航弹，对敌方单位造成伤害；
          </p>
          <p>
              定位轰炸：天火发射一枚引导弹，对敌方单位造成害，在目标位置落下6颗航弹，每颗对命中的敌方单位造成伤害。
          </p>
          <p>
              被动技能：
          </p>
          <p>
              反隐侦测：天火拥有敏锐的侦测能力，靠近天火，或被天火命中的敌方隐形单位将会显形。
          </p>
          <p>
              <img src="~@/assets/images/msbl/5.jpg" alt="">
          </p>
          <p>
              《末世部落》英雄介绍——泰坦
          </p>
          <p>
              皮糙肉厚抗击强，巨石抛射附雷电，
          </p>
          <p>
              护盾打击高防御，狂野投掷显神威。
          </p>
          <p>
              技能介绍：
          </p>
          <p>
              雷石：泰坦发射一块巨石雷拳，对敌方单位造成雷属性伤害；
          </p>
          <p>
              护盾打击：泰坦发射雷属性法球，对敌方单位造成雷属性伤害，对我方单位附加护盾值，护盾持续存在120秒；
          </p>
          <p>
              雷电涌动：泰坦发射定位弹，对敌方单位造成雷属性伤害，并在命中点区域落下数道雷电，每道闪电对敌方单位造成雷属性伤害，并对敌军附加麻痹效果，麻痹效果使敌方单位定身并禁疗，持续2回合；
          </p>
          <p>
              狂野投掷：泰坦力大无穷，抓起身边最近的敌方单位投掷出去，对敌方单位造成伤害，并在精准命中时造成敌方单位持续2回合的击晕和击飞效果。如身边无可投掷的敌方单位，则发射超级巨石雷拳，对敌方单位造成属性伤害，精准命中敌方单位时附加击晕和击飞效果，持续2回合。
          </p>
          <p>
              被动技能：
          </p>
          <p>
              护盾充能：泰坦每击败1个敌方单位，可获得2000点护盾值，不可叠加，护盾效果持续120秒。
          </p>
          <p>
              <img src="~@/assets/images/msbl/6.jpg" alt="">
          </p>
          <p>
              《末世部落》英雄介绍——圣甲虫
          </p>
          <p>
              法伤技能是主流，屏障水晶阻伤害，
          </p>
          <p>
              震荡击飞附眩晕，披甲防御递减伤。
          </p>
          <p>
              技能介绍：
          </p>
          <p>
              水晶弹：圣甲虫发射蕴含魔能的水晶弹，对敌方单位造成魔法伤害；
          </p>
          <p>
              冲击水晶：圣甲虫发射高能冲击水晶，对敌方单位造成魔法伤害并击飞目标；
          </p>
          <p>
              屏障水晶：圣甲虫发射屏障水晶，可治疗友军生命，对敌方单位将造成魔法伤害，并且在命中点生成魔法屏障，魔法屏障可阻挡伤害，持续2回合；
          </p>
          <p>
              震荡水晶：圣甲虫发射超能震荡水晶，对敌方单位造成魔法伤害并击飞目标，且附加击晕效果，使其无法进行任何行动，持续2回合。
          </p>
          <p>
              被动技能：
          </p>
          <p>
              披甲防御：圣甲虫拥有抵御连续攻击的能力，在同一回合内，受到攻击将依次递减，每次10%，最低至50%。
          </p>
          <p>
              <img src="~@/assets/images/msbl/7.jpg" alt="">
          </p>
          <p>
              《末世部落》英雄介绍——怒风
          </p>
          <p>
              一箭穿云战四方，中毒暴击无可挡。
          </p>
          <p>
              无视防御皆穿透，满血增伤威力强。
          </p>
          <p>
              技能描述：
          </p>
          <p>
              弩箭：怒风发射一支弩箭，对敌方单位造成伤害；
          </p>
          <p>
              剧毒箭：怒风发射一支剧毒箭，对敌方单位造成伤害，并附加中毒效果，中毒目标每秒造成中毒伤害，持续100秒。如目标已处于中毒状态下，则使其剩余中毒伤害一次性立即产生伤害，并重新附加新的中毒状态；
          </p>
          <p>
              暴击箭：怒风发射一支暴击箭，对敌方单位造成伤害，暴击箭触发暴击时，拥有额外的30%概率增加额外的暴击伤害50%；
          </p>
          <p>
              穿心箭：怒风发射一支穿心箭，对敌方单位造成伤害，穿心箭拥有穿透效果，可穿透一切屏障、护盾、力场等召唤物，并拥有巨大威力。
          </p>
          <p>
              被动技能：
          </p>
          <p>
              箭客信条：怒风的箭矢攻击生命值全满的敌方单位时，伤害增加20%。
          </p>
          <p>
              <img src="~@/assets/images/msbl/8.jpg" alt="">
          </p>
          <p>
              《末世部落》英雄介绍——烈火
          </p>
          <p>
              3发齐射是底线，饱和攻击威力强，
          </p>
          <p>
              烟幕一成瞄准难，飞的久点能增伤。
          </p>
          <p>
              技能介绍：
          </p>
          <p>
              飞弹散射：烈火发射3发飞弹，每发对敌方单位造成伤害；
          </p>
          <p>
              烟幕弹：烈火发射6枚烟幕弹，每发对敌方单位造成伤害并在命中点生成烟幕。烟幕内敌方单位瞄准线长度减半，持续N回合；
          </p>
          <p>
              赤色弹幕：烈火发射9发飞弹，组成的矩阵弹幕，每发飞弹对敌方单位造成伤害；
          </p>
          <p>
              烈火飞弹：连续发射烈火飞弹，以饱和攻击的方式造成巨大的范围伤害及地形破坏效果，每发飞弹造成火属性伤害。
          </p>
          <p>
              被动技能：
          </p>
          <p>
              让炮弹飞：烈火的飞弹威力随飞行时间逐渐增长，最多增加至，让炮弹飞一会。
          </p>
          <p>
              <img src="~@/assets/images/msbl/9.jpg" alt="">
          </p>
          <p>
              《末世部落》英雄介绍——雷霆
          </p>
          <p>
              电光闪击附电解，追加闪电增伤害，
          </p>
          <p>
              异化电击很看脸，连锁攻击最惊险。
          </p>
          <p>
              技能介绍：
          </p>
          <p>
              电光闪击：雷霆发射一枚电光球，对敌方单位造成雷属性伤害，并对敌方单位附加电解效果，持续8秒；
          </p>
          <p>
              球形闪电：雷霆发射一枚高级电光球，对敌方单位造成伤害，如命中处于电解状态的敌方单位则本次攻击的基础伤害增强50%；
          </p>
          <p>
              异化电击：雷霆发射一股不稳定的电流，命中敌方单位时70%概率造成雷属性伤害，30%概率恢复敌方单位生命值；
          </p>
          <p>
              连锁闪电：雷霆发射连锁闪电，对命中的第一个敌方单位造成雷属性伤害，精准命中时从命中的敌方身上生成连锁闪电并向附近的英雄单位进行传递攻击，闪电每次传递时伤害递减，最多传递5次
          </p>
          <p>
              被动技能：
          </p>
          <p>
              导电性：雷霆闪电拥有强大的穿透力，雷霆所有技能都附加穿透效果。
          </p>
          <p>
              <img src="~@/assets/images/msbl/10.jpg" alt="">
          </p>
          <p>
              《末世部落》英雄介绍——毁灭
          </p>
          <p>
              尖端武器威力大，各种导弹齐轰炸，
          </p>
          <p>
              毁灭高暴伤害强，辉光降临全铲平。
          </p>
          <p>
              技能介绍：
          </p>
          <p>
              爆破雷：毁灭发射爆破雷，对敌方单位造成伤害，爆破雷拥有强大的地形破坏能力；
          </p>
          <p>
              高爆弹：毁灭发射高爆弹，对敌方单位造成伤害，高爆弹威力巨大；
          </p>
          <p>
              毁灭者：毁灭者弹拥有巨大的威力和强大的地形破坏能力，对敌方单位造成伤害，爆炸后会分裂出2发爆破雷，每发可对敌方单位造成伤害。
          </p>
          <p>
              辉光降临：终极力量，辉光降临一切目标将无法抵御，对敌方单位造成巨大伤害。
          </p>
          <p>
              被动技能：
          </p>
          <p>
              炮击模式：架起高炮的战车拥有更大的威力，我方回合开始时毁灭威力+10%直至回合结束，任何移动操作将导致威力提升的效果消失。
          </p>
          <p>
              <img src="~@/assets/images/msbl/11.jpg" alt="">
          </p>
          <p>
              《末世部落》英雄介绍——海怪
          </p>
          <p>
              控水之术无人及，水球攻击很神奇，
          </p>
          <p>
              潮汐领域增伤害，无尽黑暗笼罩你。
          </p>
          <p>
              技能介绍：
          </p>
          <p>
              水球弹：海怪发射水球弹，对敌方单位造成水属性伤害；
          </p>
          <p>
              螺旋水球：海怪发射2发螺旋飞行的水球弹，每发对敌方单位造成水属性伤害，在2发都命中敌方单位的情况下，后命中的那1发威力会增加20%；
          </p>
          <p>
              潮汐领域：海怪释放魔法球，恢复我方单位生命，对敌方单位造成魔法伤害，且在命中点生成潮汐领域，领域内敌方单位受伤增加50%，我方单位受到伤害减免30%，持续2回合；
          </p>
          <p>
              无尽黑暗：海怪释放黑暗魔法球，对敌方单位造成魔法伤害，并附加致盲效果，使目标看不见周围战况，持续2回合。
          </p>
          <p>
              被动技能：
          </p>
          <p>
              海怪之怒：海怪生命值低于50%时，将进入狂暴状态，狂暴状态下，对敌方单位造成的伤害提高50%。
          </p>
          <p>
              <img src="~@/assets/images/msbl/12.jpg" alt="">
          </p>
          <p>
              《末世部落》英雄介绍——鬼面
          </p>
          <p>
              幽灵鬼面有特权，移动战斗不受限，
          </p>
          <p>
              月隐之术助队友，大行军术再行动。
          </p>
          <p>
              技能介绍：
          </p>
          <p>
              星火花：鬼面释放星火花，对敌方单位造成魔法伤害；
          </p>
          <p>
              双发祝福：鬼面释放双发祝福，命中的我方单位恢复生命值，并获得能连续攻击2次的双发效果，但每次威力降低，持续2回合；
          </p>
          <p>
              月隐术：鬼面释放月隐术，恢复我方单位生命值，并使我方单位进入隐身状态，隐身状态下即使被击中也不会现身，隐身效果持续2回合；
          </p>
          <p>
              大行军术：鬼面释放大行军术，恢复我方单位生命值，命中点附近范围内的我方已行动过的单位可再次行动，未行动过的我方单位会获得再次行动的BONUS。
          </p>
          <p>
              被动技能：
          </p>
          <p>
              蝠之迅捷：鬼面每回合出手后可以继续移动，最多5秒，如回合时间结束，行动也提前结束。
          </p>
          <p>
              <img src="~@/assets/images/msbl/13.jpg" alt="">
          </p>
          <p>
              《末世部落》英雄介绍——钢爪
          </p>
          <p>
              我要几度就几度，咒你永远七十度，
          </p>
          <p>
              炮弹擦身也命中，你说难受不难受！
          </p>
          <p>
              技能介绍：
          </p>
          <p>
              魔光球：钢爪发射魔光球，对敌方单位造成魔法伤害；
          </p>
          <p>
              定角诅咒：钢爪释放诅咒，造成敌方单位魔法伤害，并且对敌军附加固定发射角度的效果，使其出手永远是正面70度，持续2回合；
          </p>
          <p>
              厄运诅咒：钢爪释放厄运诅咒，对敌方单位造成魔法伤害，并且对敌方单位附加厄运效果，使其被厄运笼罩，原本会与之擦身而过的炮弹现在会被吸引而来，持续2回合；
          </p>
          <p>
              护体领域：钢爪释放护体魔法能量，恢复我方单位生命并制造守护领域，炮弹击中领域内将无法破坏地形，且友军受到伤害时减免伤害30%，持续2回合。
          </p>
          <p>
              被动技能：
          </p>
          <p>
              躯体再生：回合结束时，若钢爪本回合受到过伤害，则恢复生命值（总生命值每损失10%，恢复300生命值）。
          </p>
          <p>
              <img src="~@/assets/images/msbl/14.jpg" alt="">
          </p>
          <p>
              《末世部落》英雄介绍——毒液
          </p>
          <p>
              传播病毒威力强，buff抢来不商量，
          </p>
          <p>
              中枢入侵带穿透，能救能毒好帮手！
          </p>
          <p>
              技能介绍：
          </p>
          <p>
              病毒感染：毒液发射病毒弹，对敌方单位造成毒属性伤害，精准命中时附加&lt;病毒&gt;效果，病毒效果对敌方单位造成每N秒造成毒属性伤害，对我方单位则每N秒回复点生命。病毒携带者被命中或命中其他单位会传播病毒；
          </p>
          <p>
              病毒散播：毒液散射3发病毒弹，每发病毒弹对敌方单位造成毒属性伤害，如精准命中敌方单位则附加病毒效果；
          </p>
          <p>
              基因掠夺：发射毒液弹，对敌方单位造成毒属性伤害，精准命中可偷取目标1个正在生效的BUFF，并重置BUFF时限。包含大部分道具奖励带来的BUFF效果；
          </p>
          <p>
              中枢入侵：毒液发射超级病毒弹，对敌方单位造成毒属性伤害，附带&lt;穿透&gt;效果，如精确命中目标可将目标在场景中生成的召唤物变为毒液所有的，并重置召唤物时限。
          </p>
          <p>
              被动技能：
          </p>
          <p>
              隐蔽战术：毒液是行踪诡秘的杀手，每次击杀敌方单位，都可获得30秒隐身效果。
          </p>
          <p>
              <img src="~@/assets/images/msbl/15.jpg" alt="">
          </p>
          <p>
              《末世部落》英雄介绍——德古拉
          </p>
          <p>
              吸血能手德古拉，血祭60秒不叠加，
          </p>
          <p>
              血池法阵群治愈，血疫伤人又利己。
          </p>
          <p>
              技能介绍：
          </p>
          <p>
              血袭：德古拉释放黑暗魔法血袭，对敌方单位造成魔法伤害；
          </p>
          <p>
              血祭：德古拉释放黑暗魔法血祭，对敌方单位造成魔法伤害，精准命中可附加祭祀效果，血祭为魔法伤害，敌方单位每5秒生命值减少200，,德古拉回复对应生命值，祭祀效果存在60秒，不能叠加；
          </p>
          <p>
              血池：德古拉释放魔法，治疗我方单位生命，对敌方单位造成魔法伤害，并生成存在2回合的血池，魔法阵内我方单位的治疗效果加倍，敌方单位治疗效果减半，德古拉自身在血池内可获得闪避效果；
          </p>
          <p>
              血疫：德古拉释放黑暗魔法血疫，造成敌方单位魔法伤害，并附加供给效果，使敌方单位在攻击时产生伤害的30%转换为生命值给血疫的发射者德古拉，供给效果持续2回合；
          </p>
          <p>
              被动技能：
          </p>
          <p>
              吸血：德古拉造成伤害时，30%的伤害会转化为生命值给德古拉自身恢复。
          </p>
          <p>
              <img src="~@/assets/images/msbl/16.jpg" alt="">
          </p>
          <p>
              《末世部落》英雄介绍——崔德沃
          </p>
          <p>
              回春圣手崔德沃，清除负面很不错，
          </p>
          <p>
              治疗增益很全能，法伤威力更是强。
          </p>
          <p>
              技能介绍：
          </p>
          <p>
              枯萎之灵：崔德沃释放枯萎之灵，对敌方单位造成魔法伤害，并附加禁疗效果，使目标无法恢复生命，持续2回合；
          </p>
          <p>
              治愈之灵：崔德沃释放治愈之灵，恢复我方单位单位生命值并清除大部分负面状态；
          </p>
          <p>
              绽放之灵：崔德沃释放绽放之灵，恢复我方单位生命值，精准命中使我方单位获得威力增加50%的效果，持续2回合；
          </p>
          <p>
              均衡之灵：崔德沃释放均衡之灵，被命中的我方单位恢复生命值，被命中的敌方单位造成魔法伤害，均衡之灵拥有巨大的魔法能量，拥有巨大的威力及地形破坏能力。
          </p>
          <p>
              被动技能：
          </p>
          <p>
              回春：崔德沃对敌方单位造成伤害时，10%的伤害会作为生命值转化给自己恢复。
          </p>
          <p>
              <img src="~@/assets/images/msbl/17.jpg" alt="">
          </p>
          <p>
              《末世部落》英雄介绍——布克尔
          </p>
          <p>
              魔法之灵布克尔，先天魔抗免疫强，
          </p>
          <p>
              多重施法1换多，全能辅助不背锅。
          </p>
          <p>
              技能介绍：
          </p>
          <p>
              魔法弹：布克尔发射魔法弹，对敌方单位造成魔法伤害；
          </p>
          <p>
              螺旋魔法弹：布克尔发射3颗螺旋缠绕的魔法弹，每发魔法弹对敌方单位造成魔法伤害；
          </p>
          <p>
              多重施法：布克尔用魔力输入目标体内，恢复我方单位生命值，使其单发技能暂时变为散弹状态，但每发的威力降低，效果持续2回合；
          </p>
          <p>
              魔能灌注：布克尔释放超级魔法能量，恢复我方单位生命值，并使其技能威力增加，受到的伤害减少，持续3回合；
          </p>
          <p>
              被动技能：
          </p>
          <p>
              魔力抵抗：布克尔是魔法之灵，天生魔力抗性增加。
          </p>
          <p>
              <img src="~@/assets/images/msbl/18.jpg" alt="">
          </p>
        </div>
        <!-- <div class="product-download">
          <p class="download-title">PLATFORMS</p>
          <div class="download-box">
            Coming Soon…
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
  export default{
    data(){
      return{
        resDatas:''
      }
    },
    props: {
        resData: {}
    },
    watch: {
        resData(newData){
          this.resDatas=newData;
        }
    },
    methods:{

    },
    mounted() {
      this.$parent.getlan();
    }
  }
</script>

<style scoped>
  .product{
    width: 50%;
    margin: auto;
    box-sizing: border-box;
    padding-top: 3%;
  }
  .product-list{
    padding: 2%;
    background-color: white;
  }
  .product-list:nth-of-type(1){
    margin-bottom: 2%;
  }
  .title{
    font-size: 20px;
    font-weight: 600;
    color: #57749C;
    padding: 2% 3%;
    border-bottom: 1px solid #57749C;
  }
  .product-main{

  }
  .product-banner{
    padding: 2%;
  }
  .product-banner img{
    width: 100%;
    display: block;
  }
  .product-text{
    font-size: 16px;
    word-break: break-all;
  }
  .product-text p{
    margin-top: 5px;
  }
  .product-text p img{
    width: 100%;
  }
  .product-download{
    background-color: #E7EBF1;
    padding: 1.5% 2%;
    margin-top: 1%;
  }
  .product-download .download-title{
    color: #5B6E88;
    font-size: 20px;
    text-align: center;
    background-color: white;
    padding: 1% 0;
    font-weight: 600;
  }
  .download-box{
      font-size: 20px;
      text-align: center;
      padding: 1% 0 0;
  }
  .download-box a{
    display: inline-block;
    cursor: pointer;
    width: 15%;
    margin: 1% 1% 0;
  }
  .download-box a img{
    width: 100%;
    display: block;
  }
  @media screen and (max-width: 1000px){
    .product{
      width: 95%;
    }
    .product-list{
      padding: 2% 2% 3%;
      background-color: white;
    }
    .product-list:nth-of-type(1){
      margin-bottom: 3%;
    }
    .product-download{
      padding: 3%;
    }
    .download-box a{
      margin: 3% 3% 0;
      width: 34%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/productMSBL.vue